import React from "react";
import { PRICING_TABLE_INTENT } from "utils/constants/pricing";
import { STATE_KEYS } from "utils/constants/state";
import MenuNavList from "components/FormerEditor/MenuNavList";
import { useFormikContext } from "formik";
import get from "lodash/get";

const Hub = () => {
  const { values } = useFormikContext();
  const layout = get(values, STATE_KEYS.MANIFEST.PRICING_LAYOUT);

  const MENU_ITEMS_CONFIG = [
    /**
     * Product order controls
     * - table product order layout
     * - create new products
     * - create new product prices
     * - manage product prices and primaries
     */
    {
      label: "Product order",
      focus: [
        {
          key: STATE_KEYS.EDITOR.PRICING_INTENT,
          value: PRICING_TABLE_INTENT.PRODUCT_ORDER
        },
        {
          key: STATE_KEYS.EDITOR.PRODUCT_ORDER_INTENT,
          value: null
        }
      ]
    },
    {
      label: "Product presentation",
      disabled: layout.length === 0,
      focus: [
        {
          key: STATE_KEYS.EDITOR.PRICING_INTENT,
          value: PRICING_TABLE_INTENT.PRODUCT_PRESENTATION
        }
      ]
    },
    {
      label: "Billing presentation",
      disabled: layout.length === 0,
      focus: [
        {
          key: STATE_KEYS.EDITOR.PRICING_INTENT,
          value: PRICING_TABLE_INTENT.BILLING_TYPE
        }
      ]
    },
    {
      label: "Top features",
      disabled: layout.length === 0,
      focus: [
        {
          key: STATE_KEYS.EDITOR.PRICING_INTENT,
          value: PRICING_TABLE_INTENT.FEATURE_LIST
        }
      ]
    }
  ];

  return <MenuNavList config={MENU_ITEMS_CONFIG} />;
};

export default Hub;
